import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { BaseGridTemplate } from '../../../../shared/cgp-grid/base-cgp-grid.template';
import { Observable } from 'rxjs/Rx';
import { cgpAuthentication } from '../../../../../modules/cgp-authentication';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

import { TntToolService } from '../../tnt.service';
import {
  GlobalRegionService,
  CenterService,
  UserService,
} from '../../../mesc/mesc.service';

@Component({
  selector: 'tool-teamcenter-link',
  templateUrl: './tool-teamcenter-link.component.html',
  host: { 'style': 'width: 100%' },

  styleUrls: ['./tool-teamcenter-link.component.scss']
})
export class ToolTeamcenterLinkComponent extends BaseGridTemplate implements OnInit {
  regionState: any[];
  selectedRegion: any;
  centerState: any[];
  selectedCenter: any;
  toolsCreatedFromDate: Date;
  toolsCreatedToDate: Date;
  toolState: any[] = [];
  toolNumberFromState: any[];
  toolNumberToState: any[];
  toolsTotal: number;
  toolFilter: Subject<any> = new BehaviorSubject<any>(true);
  customFormDialogTemplate: Subject<any> = new BehaviorSubject<any>(null);
  formDialog = undefined;
  isFiltersValid: boolean = false;
  isFilterByToolNumber: boolean = false;
  filterItem: boolean;
  fromToolNumber: any;
  toToolNumber: any;
  customTemplate: any;
  userState: Subject<any[]> = new BehaviorSubject<any[]>([]);
  selectedRows: any[] = [];
  month = new Date().getMonth() + 1;

  constructor(
    private formBuilder: FormBuilder,
    public regionService: GlobalRegionService,
    public centerService: CenterService,
    public toolService: TntToolService,
    private userService: UserService,
    private cgpAlertDialogService: CgpAlertDialogService,
  ) { super(); }

  ngOnInit() {
    this.regionService.read()
      .then(response => this.regionState = response);
    this.centerService.read()
      .then(response => this.centerState = response);
    this.toolFilter.subscribe(data => {
      this.toolState = data;
      this.filterToolNumbers(data);
    })
    this.userService.read().then(response => this.userState.next(response));
    this.customFormDialogTemplate.subscribe(template => this.customTemplate = template);
    this.customFormDialogTemplate.next(null);
  }


  toggleFilter() { this.filterItem = !this.filterItem }


  filterToolNumbers(data: any[]) {
    this.toolNumberFromState = data;
    this.toolNumberToState = data;

    if (this.isFilterByToolNumber) {
      let fromIndex = this.toolState.indexOf(this.fromToolNumber),
        toIndex = this.toolState.indexOf(this.toToolNumber);
      if (fromIndex > -1) this.toolNumberToState = this.toolState
        .filter((item, i) => i > fromIndex);
      if (toIndex > -1) this.toolNumberFromState = this.toolState
        .filter((item, i) => i < toIndex);
    }
    else {
      this.fromToolNumber = undefined;
      this.toToolNumber = undefined;
    }
  }


  updateFilters(dataItem: any) {
    this.isFiltersValid = this.selectedRegion && this.selectedCenter;
    this.isFilterByToolNumber = false;
    if (!this.isFiltersValid) this.toolState = [];
    this.toggleFilter();
  }


  handleRegionChange(dataItem: any) {
    this.selectedRegion = dataItem;
    this.updateFilters(dataItem);
  }


  handleCenterChange(dataItem: any) {
    this.selectedCenter = dataItem;
    this.updateFilters(dataItem);
  }


  handleToolsCreatedDateChange(dataItem: any, from: boolean) {
    from ?
      this.toolsCreatedFromDate = dataItem :
      this.toolsCreatedToDate = dataItem;

    this.toggleFilter();
  }


  handleFromToolNumberChange(dataItem: any) {
    this.fromToolNumber = dataItem;
    if (dataItem) {
      this.isFilterByToolNumber = true;
      let index = this.toolState.indexOf(dataItem);
      this.toolNumberToState = this.toolState.filter((item, i) => i > index);
    } else {
      this.toolNumberToState = this.toolState;
    }

    this.toggleFilter();
  }


  handleToToolNumberChange(dataItem: any) {
    this.toToolNumber = dataItem;
    if (dataItem) {
      this.isFilterByToolNumber = true;
      let index = this.toolState.indexOf(dataItem);
      this.toolNumberFromState = this.toolState.filter((item, i) => i < index);
    } else {
      this.toolNumberFromState = this.toolState;
    }

    this.toggleFilter();
  }


  getParam(dataItem, field) {
    return dataItem ? dataItem[field] : undefined;
  }


  handleRead = (force, dataItem, state): Promise<any> => {
    if (this.isFiltersValid) {
      let page = state.skip ? (state.skip / state.take) + 1 : 1;

      let urlExtension = "/search?" +
        "pageSize=" + state.take +
        "&pageNumber=" + page +
        "&toolsWithNoTeamCenterLink=true",

        fieldName = "TntTools",
        filters = {
          ToolsWithNoTeamCenterLink: true,
          CenterId: this.selectedCenter.Id,
          GlobalRegionId: this.selectedRegion.Id,
          FromToolNumber: this.getParam(this.fromToolNumber, 'ToolNumber'),
          ToToolNumber: this.getParam(this.toToolNumber, 'ToolNumber'),
          CreatedFromDate: this.toolsCreatedFromDate,
          CreatedToDate: this.toolsCreatedToDate,
        }
      return this.toolService.post(filters, urlExtension, fieldName)
        .then(data => {
          this.toolsTotal = data.RecordCount;
          this.toolFilter.next(data.TntTools ? data.TntTools : data);
          return Promise.resolve(<GridDataResult>{
            data: this.toolState,
            total: data.RecordCount
          });
        })
    } else {
      return Promise.resolve(this.toolState)
        .then(data => this.toolFilter.next(data));
    }
  }


  handleSelect = (selected: any[]) => {
    this.selectedRows = selected;
  }

  setModelHandler() { }


  customSaveHandler(dataItem: any) {
    this.selectedRows.map(x => {
      let item = this.toolService.data.find(tool => x.dataItem.Id === tool.Id);
      if (item) item.TeamCenterLink = dataItem.TeamCenterLink;
    })

    let response = this.toolService.data
      .filter(item => item.TeamCenterLink !== null)

    this.customFormDialogTemplate.next(null);
    this.toolService
      .save(response, false, '/teamcenter', false, false, false)
      .then(response => this.toggleFilter())
      .catch(x => {
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: x._body ? x._body.replace(/"/g, '') : '',
          alert: 'danger',
          closeLabel: 'Close',
        })
      });


  }


  customCancelHandler() {
    this.customFormDialogTemplate.next(null);
  }

  /****************************************************************************
   * Add Team Center Link for Selected
   ***************************************************************************/
  addTeamCenterLinks = () => {

    let dataItem: any = { SelectedCount: this.selectedRows.length };
    this.editForm.reset(dataItem);

    let template = {
      isNew: true,
      title: this.teamCenterLinkFormDialog.title,
      editForm: this.editForm,
      formControls: this.teamCenterLinkFormDialog.formControls,
    }

    this.customFormDialogTemplate.next(template);
  }


  handleControlDisabled = (controlName: string) => {
    let isDisabled: boolean = false;
    switch (controlName) {
      case 'excel':
        isDisabled = !this.isFiltersValid;
        break;
      case 'teamCenterLinks':
        isDisabled = this.selectedRows.length < 1;
        break;
      default:
        break;
    }
    return isDisabled;
  }

  editForm = this.formBuilder.group({
    SelectedCount: [0],
    TeamCenterLink: ['', Validators.required]
  });

  teamCenterLinkFormDialog = {
    title: "Team Center Links (Bulk)",
    formControls: [{
      type: "value",
      title: "Selected Total:",
      name: "SelectedCount",
    }, {
      type: "text",
      name: "TeamCenterLink",
      title: "Team Center Link",
    }]
  }

  addNewDateTemplateControl = {
    id: "teamCenterLinks",
    iconClass: "fa fa-link",
    title: "Add Team Center Link for Selected",
    text: "Add Team Center Link (Bulk)",
    callback: this.addTeamCenterLinks,
  }

  columns = [
    {
      field: 'ToolNumber',
      title: 'Tool Number',
    },
    {
      field: 'ToolDescription',
      title: 'Description',
    },
    {
      field: 'RegionName',
      title: 'Region',
    },
    {
      field: 'CenterName',
      title: 'Center',
    },
    {
      field: 'Ownername',
      title: 'Tool Owner',
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }
    }
  ]

  template = {
    title: "TNTS Tools",
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: true,
      width: 10,
      customToolbar: [
        this.addNewDateTemplateControl,
      ],
      isDisabled: this.handleControlDisabled,
    },
    fileName: "ToolsWithoutTeamCenterLink_" + cgpAuthentication.getUserInfo().sn + "_" + new Date().getDate() + "-" + this.month + "-" + new Date().getFullYear() + ".xlsx",
    selectable: true,
    columns: this.columns,
    service: [],
    read: this.handleRead,
    select: this.handleSelect,
  }

}


